// 배포 시간 정보 (수동 설정)
export const BUILD_INFO = {
  buildTime: '250102-15:30:00 KST'
};